<template>
  <div class="case">
    <div class="neiy">
      <div class="commen">
        <div class="bt reveal-usercasetop">
          <h6>案例</h6>
          <img src="@/view/images/y8.png" />
        </div>
        <div class="all">
          <div class="ald fl reveal-usercasetop">
            <a>
              <img src="@/view/images/case1.jpg" />
              <h6>青岛兴达包装科技有限公司</h6>
              <p>
                是岛城集印刷、设计、后加工于一体的一站式专业印刷企业，专业的设计服务，先进的印刷设备，高素质的生产管理人员，在高端包装盒的市场上享有赞誉，是一家集研发，生产，服务为一体的科技型印刷企业。
                是青岛包装印刷中的知名企业。
                随着市场客户的结构变化，高端业务需求的产生，买方客户对印刷质量评测方法，有了更高的标准要求。从主观评价法，逐步转化为以数值化为验收标准，依靠传统的经验和工艺办法，已经不能满足当下的市场需求。
                2020年9月份，兴达印务与印工社签约印刷管家服务，把印刷生产当中的设备，材料，人员操作等一系列的变量优化后进行固化，数据化控制，从而以标准的生产模式生产出标准的印品。
                印刷管家服务不仅仅是能够解决色差，提高印刷质量，还能够提升设备的有效利用率，缩短交期，降低废品率等问题。从产品质量，价格，效率层面为企业带来整体的竞争力提升。
              </p>
            </a>
          </div>
          <div class="ald fl reveal-usercasetop">
            <a>
              <img src="@/view/images/case2.jpg" />
              <h6>青岛奥德圣包装制品有限公司</h6>
              <p>
                青岛奥德圣包装制品有限公司,2009年08月28日成立，经营范围包括纸制包装箱，包装装潢印刷品印刷，是岛城大彩箱包装印刷的知名企业。
                业务类型以长单居多，以品牌业务居多，因此对色彩复制的一致性有十分迫切的需求。
                2021年3月份，签约了印工社的印刷管家服务，从员工的理论培训，到设备保养校正，标准化体系的建立，印前，制版的标准化流程等四大环节进行了落地式服务。从之前的凭借经验校色到数字化的检测体系，
                极大了缩短了机台校色时间，使印刷机的有效利用率提升30%。
              </p>
            </a>
          </div>
          <div class="ald fl reveal-usercasetop">
            <a>
              <img src="@/view/images/case3.jpg" />
              <h6>北京顶佳世纪印刷有限公司</h6>
              <p>
                北京顶佳世纪印刷有限公司（以下简称“顶佳印刷”）成立于2001年，做为北京顶佳创世纪投资公司（topcent）的下属单位，是一家以高档商务印刷、书刊印刷为核心的规模化、现代化的印刷生产企业。
                公司装备精良，拥有4台世界好的的德国海德堡四色印刷机，并配有胶订联动线、双色印刷机等成套装订或辅助设备。公司生产基地位于北京市大兴区西红门镇，建筑面积达2万余平方米，现有员工160余名，注册资本5000万元，固定资产6千余万元。
                “顶佳印刷”以“诚信共赢”为发展的基石，一贯秉承“高标准、高质量、精细化”的作业理念，精益求精，不断超越，先后通过ISO9001、ISO14001等国际管理体系认证，并获得“北京市高新技术企业”称号。
                依靠自身实力和不懈努力，通过招投标或遴选过程，“顶佳印刷”与国内外众多知名的企事业单位（如中国移动、摩托罗拉、爱普生、富士施乐、中国移动、中国银行、中银保险等）建立了长期的互利合作关系，成为其商务印刷品供应商，同时作为“北京市政府定点印刷采购单位”，“顶佳印刷”还与向众多政府机关（如市公安局、市计划生育委员会等）具有合作关系，产品和服务深受信赖。常年服务国内外的一线品牌。
                正因为业务范围广、要求高，因此顶佳对色彩复制一致性有迫切需求。自2020年5月份签约了印工社印刷管家服务体系，从印前色彩控制流程梳理，样张质量评测系统软硬件的熟练实用，以及色彩管理整个体系的运营，加上车间机组的全力配合，印刷机状态稳定，水箱检测系统数据化的配合下，快速形成了色彩管理闭环。不仅仅品质进一步提升，在交期方面也获得了巨大的提升。
              </p>
            </a>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'caseName',
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/case.vue